import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material.module';
import { NotificationComponent } from './notification.component';
import { PushNotifyComponent } from './push-notify/push-notify.component';
import { NotificationHelper } from './notification-helper';
import * as moment from 'moment';
import { TranslateModule } from '@ngx-translate/core';

@Pipe({ name: 'fromNow' })
export class RelativeTimePipe implements PipeTransform {
   transform(value: any): any {
      return moment(value).fromNow();
   }
}

@NgModule({
   imports: [
      CommonModule,
      RouterModule,
      TranslateModule,
      MaterialModule
   ],
   declarations: [
      NotificationComponent,
      PushNotifyComponent,
      RelativeTimePipe
   ],
   exports: [NotificationComponent],
   providers: [NotificationHelper, RelativeTimePipe]
})
export class NotificationModule { }
